import $ from 'jquery';
import svg4everybody from 'svg4everybody';
import {initAPI} from './api/initAPI';
import {loadPolyfills} from 'Utils/polyfills';
import {loadComponents} from 'Utils/load-components';
import {loadCMS} from './cms/loadCMS';

// load exposed methods before dom ready
try {
  initAPI();
}
catch (error) {
  console.error('Failed to load API:', error);
}

$(document).ready(function ($) {

    // load polyfills
    try {
        loadPolyfills();
    }
    catch (error) {
        console.error(error);
    }

    // load CMS modules
    try {
      loadCMS();
    }
    catch (error) {
      console.error(error);
    }

    // SVG fallback for IE
    svg4everybody();

    // load front components
    try {
      loadComponents($);
    }
    catch (error) {
      console.error(error);
    }
});


// WEBPACK FOOTER //
// ./src/js/index.js